import { render, staticRenderFns } from "./CompanySubscriptionPlanForm.vue?vue&type=template&id=6968c2f0"
import script from "./CompanySubscriptionPlanForm.vue?vue&type=script&lang=js"
export * from "./CompanySubscriptionPlanForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports